var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcRefreshArrow = function SvgIcRefreshArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.578 7.75C6.968 5.21 9.566 3.5 12.54 3.5c3.374 0 6.262 2.197 7.455 5.313m-11.977 0H4v-4.25M19.422 16.25c-1.39 2.54-3.988 4.25-6.963 4.25-3.374 0-6.262-2.197-7.455-5.313m11.977 0H21v4.25",
    stroke: "#828C97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIcRefreshArrow;